var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5144 44H42.4857C46.9363 44 49.5471 38.5873 46.9989 34.6425L29.0395 6.84044C26.5932 3.05319 21.4069 3.05319 18.9603 6.84044L1.00084 34.6425C-1.5469 38.5873 1.06382 44 5.5144 44Z",
    fill: "#FF737D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9995 29.8162C22.3197 29.8162 20.9453 28.4418 20.9453 26.762V14.5067C20.9453 12.8265 22.3197 11.4521 23.9995 11.4521C25.6793 11.4521 27.0537 12.8265 27.0537 14.5067V26.762C27.0537 28.4418 25.6793 29.8162 23.9995 29.8162Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0159 35.6281C27.0159 37.2936 25.6657 38.6434 24.0001 38.6434C22.3346 38.6434 20.9844 37.2936 20.9844 35.6281C20.9844 33.9625 22.3346 32.6123 24.0001 32.6123C25.6657 32.6123 27.0159 33.9625 27.0159 35.6281Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.04440ff7df45855f78eefc17bebf44ef.svg";
export { ForwardRef as ReactComponent };